export const isDesktop = () => window.innerWidth >= 992;
